<template>
    <div class="accordion">
        <div class="accordion__header">
            <span class="accordion__header__title" :class="active ? 'accordion--active' : ''" @click.prevent="active = !active">
                {{title}}
                <icon class="accordion__header--icon" v-show="!active" icon="chevron-down" />
                <icon class="accordion__header--icon" :class="active ? 'accordion--active' : ''" v-show="active" icon="chevron-up" />
            </span>
        </div>
        <div class="accordion__content" v-show="active">
            <slot />
        </div>            
    </div>
</template>

<script>

export default {        
  props: [
    'title'
  ],
  data() {
    return {
      active: false,
    }
  }
}
</script>

<style scoped lang="scss">
    @import '../../../scss/controls/_accordion.scss';
</style>